import React from 'react';

export declare type FocusType = 'false' | 'true';

export type IconProps = {
  className?: string;
  color?: string;
  focusable?: FocusType;
  height?: number;
  onClick?: () => void;
  size?: number;
  width?: number;
};

export const PhoneCall: React.FC<IconProps & JSX.IntrinsicElements['svg']> = ({
  className = '',
  color = '#090C33',
  focusable = 'false',
  height,
  onClick,
  size = 24,
  width,
  ...rest
}) => {
  const iconColor = undefined;

  return (
    <svg
      fill="none"
      height={height || size}
      width={width || size}
      onClick={onClick}
      className={className}
      focusable={focusable}
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        stroke={iconColor || color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14 1a9 9 0 019 9m-9-5a5 5 0 015 5m-4.692 5.191L12.167 17.3a17.408 17.408 0 01-3.092-2.376 17.606 17.606 0 01-2.375-3.09l2.11-2.141a.918.918 0 00.189-1L6.8 3.56a.918.918 0 00-1.078-.525L1.688 4.1A.92.92 0 001 5.019a19.4 19.4 0 005.49 12.492A19.4 19.4 0 0018.986 23a.917.917 0 00.917-.688l1.066-4.036a.917.917 0 00-.524-1.078L15.316 15a.917.917 0 00-1.008.191z"
      />
    </svg>
  );
};
